
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us-economy",
      function () {
        return require("private-next-pages/us-economy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us-economy"])
      });
    }
  